import React from 'react';
import { motion } from 'framer-motion';

const FEATURES = [
  {
    title: 'Certified',
    sub: 'Certificates of authenticity',
    svg: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
  },
  {
    title: 'Shipping',
    sub: 'Free, fast and reliable',
    svg: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="1" />
        <path d="M16 8h4l3 5v4h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    ),
  },
  {
    title: 'Secure',
    sub: 'Certified Marketplace',
    svg: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        <circle cx="12" cy="16" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: 'Transparent',
    sub: 'Hassle-free return policy',
    svg: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 11l19-9-9 19-2-8-8-2z" />
      </svg>
    ),
  },
];

const FeaturesBar = () => {
  return (
    <>
      <style>{`
        .fb-wrap {
          width: 100%;
          background: #ffffff;
          border-top: 1px solid #f0ebe3;
          border-bottom: 1px solid #f0ebe3;
          display: flex;
          align-items: stretch;
          justify-content: center;
          flex-wrap: wrap;
        }
        .fb-item {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 32px 60px;
          flex: 1;
          min-width: 240px;
          position: relative;
          transition: background 0.2s;
        }
        .fb-item:last-child { border-right: none; }
        .fb-item:hover { background: #fdf9f4; }
        .fb-icon {
          flex-shrink: 0;
          width: 54px;
          height: 54px;
          border: 1.5px solid #B08D57;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #B08D57;
          transition: background 0.2s, color 0.2s;
        }
        .fb-item:hover .fb-icon {
          background: #B08D57;
          color: #fff;
        }
        .fb-title {
          font-family: 'Jost', sans-serif;
          font-size: 15px;
          font-weight: 600;
          color: #1C1A18;
          letter-spacing: 0.05em;
          margin-bottom: 4px;
        }
        .fb-sub {
          font-family: 'Jost', sans-serif;
          font-size: 13px;
          font-weight: 400;
          color: #9A9186;
          letter-spacing: 0.02em;
        }

        @media (max-width: 768px) {
          .fb-item {
            flex: 0 0 50%;
            min-width: 0;
            padding: 18px 20px;
          }
        }
        @media (max-width: 380px) {
          .fb-item { flex: 0 0 100%; border-right: none; }
          .fb-item:last-child { border-bottom: none; }
        }
      `}</style>

      <motion.div
        className="fb-wrap"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        {FEATURES.map((f, i) => (
          <motion.div
            key={f.title}
            className="fb-item"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="fb-icon">{f.svg}</div>
            <div>
              <div className="fb-title">{f.title}</div>
              <div className="fb-sub">{f.sub}</div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </>
  );
};

export default FeaturesBar;